<template>
  <div>
    <div class="content-wrapper" v-if="!loadingComplete()">
      <section class="content">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">Chargement en cours</h3>
            </div>
            <div class="box-body">
              Chargement de la fiche du membre
            </div>
            <div class="overlay">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="content-wrapper" v-if="loadingComplete()">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          {{ this.getMember.fullName }}
          <small>Fiche membre</small>
        </h1>
        <ol class="breadcrumb">
          <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
          <li><a href="#">Membres</a></li>
          <li class="active">{{ this.getMember.fullName }}</li>
        </ol>
      </section>

      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="nav-tabs-custom nav-tabs-custom-bottom">
              <ul class="nav nav-tabs" role="tablist">
                <li :class="{'active':!active_tab || (active_tab && active_tab=='member_tab_1')}">
                  <a href="#member_tab_1"
                     aria-controls="#member_tab_1"
                     data-toggle="tab"
                     aria-expanded="false">Fiche
                    administrative</a>
                </li>
                <li class="">
                  <a href="#member_tab_2"
                     aria-controls="#member_tab_2"
                     data-toggle="tab"
                     aria-expanded="false">Licences</a>
                </li>
                <li class="">
                  <a href="#member_tab_3"
                     aria-controls="#member_tab_3"
                     data-toggle="tab"
                     aria-expanded="false">Stages, Examens et
                    Formations</a>
                </li>
                <li :class="{'active':active_tab && active_tab=='competitions'}">
                  <a href="#member_tab_4"
                     aria-controls="#member_tab_4"
                     data-toggle="tab"
                     aria-expanded="false">Compétitions</a>
                </li>
                <li :class="{'active':active_tab && active_tab=='arbitres'}">
                  <a href="#member_tab_7"
                     aria-controls="#member_tab_7"
                     data-toggle="tab"
                     aria-expanded="false">Arbitrages</a>
                </li>
                <li class="">
                  <a href="#member_tab_5"
                     aria-controls="#member_tab_5"
                     data-toggle="tab"
                     aria-expanded="false">Comités clubs</a>
                </li>
                <li class="">
                  <a href="#member_tab_6"
                     aria-controls="#member_tab_6"
                     data-toggle="tab"
                     aria-expanded="false">MyABFT</a>
                </li>
              </ul>

            </div>
          </div>
        </div>
        <div class="row tab-content">
          <div role="tabpanel" :class="['col-md-12 tab-pane',{'active':!active_tab || (active_tab && active_tab=='member_tab_1')}]" id="member_tab_1">
            <!--<router-view></router-view>-->
            <MainFormMember></MainFormMember>
          </div>

          <div role="tabpanel" class="col-md-12 tab-pane" id="member_tab_2">
            <FormLicenceMember></FormLicenceMember>
          </div>

          <div role="tabpanel" class="col-md-12 tab-pane" id="member_tab_3">
            <ListingStageExamensFormations></ListingStageExamensFormations>

          </div>
          <div role="tabpanel" :class="['col-md-12 tab-pane',{'active':active_tab && active_tab=='competitions'}]" id="member_tab_4">
            <ListingCompetitions></ListingCompetitions>
          </div>
          <div role="tabpanel" :class="['col-md-12 tab-pane',{'active':active_tab && active_tab=='arbitres'}]" id="member_tab_7">
            <ListingArbitrage></ListingArbitrage>
          </div>
          <div role="tabpanel" class="col-md-12 tab-pane" id="member_tab_5">
            <ListingComites></ListingComites>
          </div>
          <div role="tabpanel" class="col-md-12 tab-pane" id="member_tab_6">
            <MyABFTMembre></MyABFTMembre>
          </div>
        </div>
      </section>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import MainFormMember from './MainFormMember.vue'
import FormLicenceMember from './FormLicenceMember'
import ListingStageExamensFormations from './ListingStageExamensFormations'
import ListingCompetitions from './ListingCompetitions'
import ListingComites from './ListingComites'
import ListingArbitrage from './ListingArbitrage'
import MyABFTMembre from './MyABFTMembre'

export default {
  data() {
    return {
      active_tab: 'member_tab_1'
    }
  },
  props: {
    member_id: {
      required: true
    },
  },
  // mounted: function () {
  //   this.$nextTick(function () {
  //     this.setMember(null)
  //     this.loadMember()
  //
  //     console.log(this.active_tab)
  //   })
  // },
  computed: {
    ...mapGetters({
      getMember: 'getMember',
      getProfessions: 'getProfessions',
      getPays: 'getPays',
      getRoutes: 'getRoutes',
      getVilles: 'getVilles',
      getRoute: 'getRoute',
      getTypesLicences: 'getTypesLicences',
      getStatutsSportifs: 'getStatutsSportifs',
    })
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(vm.$route)
      if (vm.$route.query.active_tab)
        vm.active_tab = vm.$route.query.active_tab
      vm.setMember(null)
      vm.loadMember()
    })
  },

  methods: {
    ...mapActions({
      setProfessions: 'setProfessions',
      setPays: 'setPays',
      setVilles: 'setVilles',
      setMember: 'setMember',
      setTypesLicences: 'setTypesLicences',
      setStatutsSportifs: 'setStatutsSportifs',
    }),
    loadingComplete: function () {
      return this.getMember != null &&
        this.getPays != null &&
        this.getVilles != null &&
        this.getProfessions != null
    },
    loadMember: function () {
      this.$http.get(this.getRoute('getInfosMember') + this.member_id)
        .then((response) => {
          this.setMember(response.body)
        }, (response) => {
          this.setMember(null)
        });
    },

  },
  watch: {
    '$route': function () {
      // console.log("Route has changed")
      this.setMember(null)
      this.loadMember()
    }
  },
  components: {
    MainFormMember,
    FormLicenceMember,
    ListingCompetitions,
    ListingComites,
    ListingArbitrage,
    ListingStageExamensFormations,
    MyABFTMembre,
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Membre/AppMember.vue